import { useQuery } from '@tanstack/react-query'
import { useUser } from './useUser'

const API_URL = '/api/account/profile'

/**
 * Prefix of the profile query key, exported so anything that changes what the profile reports can
 * invalidate it. The full key is `[PROFILE_QUERY_KEY, user]`; React Query matches on the prefix.
 */
export const PROFILE_QUERY_KEY = API_URL

type Profile = {
    wallet_connected: boolean
    nft_owner: boolean
    usdc_deposited: boolean
}

export const useProfile = () => {
    const { data: user } = useUser()
    return useQuery<Profile>({
        queryKey: [API_URL, user],
        queryFn: async () => {
            const res = await fetch(API_URL)
            return await res.json()
        },
        retry: false,
        enabled: !!user,
        initialData: {
            wallet_connected: false,
            nft_owner: false,
            usdc_deposited: false,
        },
    })
}
